module.exports = __webpack_public_path__ + "static/media/Linkedin.694a0361.png";